import { ApiGroomingSearchRetrieveGroomingType } from '@rover/rsdk/src/apiClient/latest/model/apiGroomingSearchRetrieveGroomingType';
import type { ApiGroomingSearchRetrieveParams } from '@rover/rsdk/src/apiClient/latest/model/apiGroomingSearchRetrieveParams';
import type { GroomingSearchQuery } from '@rover/rsdk/src/apiClient/latest/model/groomingSearchQuery';

export const GROOMING_LANDING_SEARCH_PARAMS: ApiGroomingSearchRetrieveParams = {
  groomingType: ApiGroomingSearchRetrieveGroomingType.full_groom,
};

export const getSearchParamsFromQuery = (
  query: GroomingSearchQuery
): ApiGroomingSearchRetrieveParams => ({
  groomingType: query.groomingType,
  ...(query.location && { location: query.location }),
  ...(query.locationType && { locationType: query.locationType }),
  ...(Number.isFinite(query.centerlat) && { centerlat: query.centerlat }),
  ...(Number.isFinite(query.centerlng) && { centerlng: query.centerlng }),
});
